<div>
  @if (editMode && fieldConfig !== undefined && !editReadOnly) {
    <mat-form-field>
      <div [innerHtml]="label"></div>
      <input
        [hidden]="true"
        matInput
        [(ngModel)]="label"
        style="cursor: pointer"
        [errorStateMatcher]="matcher"
        #ngModel="ngModel" />
      @for (v of fieldConfig ? fieldConfig.validators : []; track v) {
        <mat-error>
          @if (condition(v, ngModel)) {
            <span>{{ message(v) }}</span>
          }
        </mat-error>
      }
      @if (loading) {
        <mat-spinner matSuffix [diameter]="16"></mat-spinner>
      }
      @if (!loading) {
        <mat-icon
          data-id="editFieldBtn"
          matSuffix
          style="font-size: 16px; cursor: pointer"
          matTooltip="Select"
          (click)="openModal()"
          >mode_edit
        </mat-icon>
      }
      @if (!loading) {
        <mat-icon
          data-id="clearBtn"
          matSuffix
          style="font-size: 16px; cursor: pointer"
          matTooltip="Clear"
          (click)="clearField()"
          >clear
        </mat-icon>
      }
    </mat-form-field>
  } @else {
    <div [innerHtml]="label" style="display: inline"></div>
    @if (data) {
      <mat-icon
        matSuffix
        class="clipboard-copy"
        [ngClass]="{ 'clipboard-copied': this.clipboardCopied }"
        matTooltip="Copy to clipboard"
        (click)="copyToClipboard()"
        >file_copy
      </mat-icon>
    }
  }
</div>
